import { MaxWidth } from 'components/MaxWidth';
import { RichText } from 'components/slices/RichText';
import { useState } from 'react';
import { useAppContext } from 'shared/useAppContext';
import { validate } from 'shared/donateSchemas';
import styles from './DonateForm.module.css';

// ---------------------------------------------------------------------------
// Hook — logica, validatie en submit gedeeld tussen beide formulieren
// ---------------------------------------------------------------------------
export function useDonateForm({ schema, apiType }) {
  const { formSettings } = useAppContext();
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const termsLink = formSettings.data.terms_link;
  const successMessage = formSettings.data.contact_thanks_message;

  const onSubmit = async (data) => {
    const parsed = {
      ...data,
      monthlyAmount: data.monthlyAmount
        ? Number(data.monthlyAmount)
        : undefined,
      amount: data.amount ? Number(data.amount) : undefined,
    };

    const { success: valid, errors } = validate(schema, parsed);
    if (!valid) {
      setFieldErrors(errors);
      return;
    }

    setFieldErrors({});
    setError(null);

    const response = await fetch(`/api/donate?type=${apiType}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(parsed),
    }).then((r) => r.json());

    if (response?.error) {
      console.error(response.error);
      setError('Er is iets misgegaan');
      if (response.fields) setFieldErrors(response.fields);
    } else {
      setSuccess(true);
    }
  };

  return { error, fieldErrors, success, termsLink, successMessage, onSubmit };
}

// ---------------------------------------------------------------------------
// Shell — afhandeling succes-state en pagina-structuur
// ---------------------------------------------------------------------------
export function DonateFormShell({ success, successMessage, children }) {
  if (success) {
    return (
      <div id="community-form" className={styles.container}>
        <MaxWidth>
          <RichText content={successMessage} />
        </MaxWidth>
      </div>
    );
  }

  return (
    <div id="community-form" className={styles.container}>
      <MaxWidth>{children}</MaxWidth>
    </div>
  );
}
